define('webshopProductsDetailBodyProductBodyIndexesView',[
  'app',
  'module',
  'backbone',
  'marionette',
  'underscore',
  'compositeView',
  'webshopProductsDetailBodyProductBodyIndexView',
  'template!webshopProductsDetailBodyProductBodyIndexesView'
], function (
  App,
  Module,
  Backbone,
  Marionette,
  _,
  CompositeView,
  IndexView,
  Tpl
) {
  'use strict';

  Module.exports = CompositeView.extend({
    template: Tpl,
    className: 'indexes-view ' + CompositeView.prototype.className,
    childView: IndexView,

    childViewOptions: function () {
      return {
        product: this.model
      };
    },

    onRender: function () {
      CompositeView.prototype.onRender.apply(this);
      this.fetch();
    },

    fetch: function () {
      this.collection.reset();
      _.each(this.options.webshopConfig.getLanguages(), _.bind(function (language) {
        var model = new Backbone.Model({
          lang: language,
          value: this.model.getIndex(language)
        });
        this.collection.add(model);
      }, this));
    }
  });
});
